module.exports = __webpack_public_path__ + "static/media/all3d_gesture.f710fbfc.gif";